export const validUrlPattern = new RegExp(
  "^(https?:\\/\\/)?" + // validate protocol
  "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // validate domain name
  "((\\d{1,3}\\.){3}\\d{1,3}))" + // validate OR ip (v4) address
  "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // validate port and path
  "(\\?[;&a-z\\d%_.~+=-]*)?" + // validate query string
  "(\\#[-a-z\\d_]*)?$",
  "i"
); // validate fragment locator`);

export const validPasswordPattern = new RegExp(/^(?=.*[A-Za-z0-9])(?=.*[^A-Za-z0-9]).{8,}$/);

export const validEmailPattern = new RegExp(/[a-z0-9]+@[a-z]+\.[a-z]{2,3}/);

export const validPhoneNumberPattern = new RegExp(/^[\d\+\-\(\) ]{10,}$/);

export const validNamePattern = new RegExp(/^[\w'\-,.][^0-9_!¡?÷?¿/\\+=@#$%ˆ&*(){}|~<>;:[\]]{2,}$/);